import React from "react";
import { injectIntl } from "react-intl";
import { Typography, makeStyles } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import { compose } from "recompose";

const useStyles = makeStyles(() => ({
  alert: {
    "& .MuiAlert-icon": {
      padding: "0",
      paddingRight: "10px",
      margin: "auto 0",
    },
    "& .MuiAlert-message": {
      padding: "0",
      margin: "auto 0",
    },
  },
}));

const RuleDescriptionRow = ({
  style,
  description,
  isVisibilityDescription = true,
}) => {
  const classes = useStyles();

  return (
    <Alert
      color="info"
      icon={
        <Typography
          variant="subtitle1"
          style={{
            width: "30px",
            height: "30px",
            textAlign: "center",
          }}
        >
          {isVisibilityDescription && <Visibility />}
          {!isVisibilityDescription && (
            <div dangerouslySetInnerHTML={{ __html: "&#9913;" }} />
          )}
        </Typography>
      }
      style={{
        ...style,
      }}
      className={classes.alert}
    >
      <Typography variant="subtitle2">{description}</Typography>
    </Alert>
  );
};

const enhance = compose(injectIntl);

export default enhance(RuleDescriptionRow);
